<template>
  <b-modal v-model="logOutNotice" size="sm" :centered="true" :no-close-on-backdrop="true" :no-close-on-esc="true">
    <div slot="modal-header">
      <div class="h6 my-0 text-uppercase">Hey! are you still there?</div>
    </div>
    <b-row class="my-4" align-v="center">
      <b-col cols="auto">
        <i class="fa fa-exclamation-triangle fa-4x text-warning"></i>
      </b-col>
      <b-col>
        <p class="h6">The application has been inactive for a while. <span class="text-danger">You'll be logged out soon</span></p>
      </b-col>
    </b-row>

    <b-row class="mt-2 mb-0 py-2 bg-light"  align-v="center">
      <b-col cols="12">
        <p class="text-muted">You'll be automatically logged out in {{logoutCountDown}} seconds unless you take action.</p>

        <b-progress class="my-2" variant="warning" :max="dismissSecs" :value="logoutCountDown" height="4px"></b-progress>

      </b-col>
    </b-row>
    <b-container slot="modal-footer">
      <b-row>
        <b-col cols="12" class="text-center">
          <b-button class="mx-2" size="sm" variant="link" @click="logout">Logout</b-button>
          <b-button class="mx-2" size="sm" variant="primary" @click="stayLoggedIn">Stay Logged In</b-button>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'logOutNotice',
  watch: {
    logoutCountDown (newVal, oldVal) {
      if (newVal === 0 && newVal !== oldVal) {
        this.logout()
      }
    }
  },
  data () {
    return {
      logOutNotice: false,
      dismissSecs: 0,
      logoutCountDown: 0,
      logOutInterval: null
    }
  },
  computed: {
    ...mapGetters(
      'user',
      [
        'isUserLoggedIn',
        'accessToken',
        'jwtData'
      ]
    ),
    ...mapGetters(
      'app',
      [
        'log',
        'latestLog'
      ]
    )
  },
  methods: {
    stayLoggedIn () {
      this.refreshToken()
      this.logOutNotice = false
      clearInterval(this.logOutInterval)
    },
    refreshToken () {
      this.$store.dispatch('user/refreshToken')
      this.handleTokenTimeout()
    },
    logout () {
      this.$store.dispatch('user/logout')
    },
    showLogOutNotice () {
      this.logOutNotice = true
      let timeNow = Date.now() / 1000
      let jwtExp = this.jwtData.exp
      let timeDiff = Math.round(jwtExp - timeNow)
      this.dismissSecs = timeDiff
      this.logoutCountDown = timeDiff
      this.logOutInterval = setInterval(() => {
        this.logoutCountDown = this.logoutCountDown - 1
      }, 1000)
    },
    logOutOrRefreshToken () {
      if (this.latestLog) {
        let lastActiveTimeMin = (this.latestLog.timestamp / 1000)
        let timeNowMin = (Date.now() / 1000)
        let timeDiff = timeNowMin - lastActiveTimeMin
        let timeDiffMin = Math.round(timeDiff / 60)

        if (timeDiffMin < 5) {
          this.refreshToken()
        } else {
          this.showLogOutNotice()
        }
      } else {
        this.showLogOutNotice()
      }
    },
    handleTokenTimeout () {
      let timeNow = Date.now() / 1000
      let jwtExp = this.jwtData.exp
      let timeDiff = jwtExp - timeNow
      let timeDiffMin = Math.round(timeDiff / 60)
      let timeDelta = 5
      if (timeDiffMin < timeDelta) {
        this.logOutOrRefreshToken()
      } else {
        let t = ((timeDiffMin - timeDelta) * 60) * 1000
        setTimeout(this.handleTokenTimeout, t)
      }
    }
  },
  created () {
    if (this.isUserLoggedIn) {
      this.$store.dispatch('app/addSuccessLog', { message: 'Application loaded' })
      this.handleTokenTimeout()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LogoutNotification.vue